import React, { Fragment } from "react";
import styles from "./AboutPage.module.css";
import Header from "./Header";
import FadeInOnScroll from "./UI/FadeInOnScroll";

import pdga from "../Assets/pdga.png";
import parks from "../Assets/parks.png";

const AboutPage = () => {
  return (
    <Fragment>
      <Header intro="About Hyzerberg Technologies"></Header>
      <div className={styles.content}>
        <div className={styles.about}>
          <FadeInOnScroll>
            <div className={styles.block}>
              <h2>About</h2>
              <p>
                Hyzerberg Technologies is a senior Capstone project for the Wake
                Forest University Engineering department. The goal of the
                project is to develop a disc golf simulator, similar to a
                traditional golf simulator you may see at a golf store or a
                barcade.
              </p>
              <p>
                The group has been hard at work over the past 6 months trying to
                develop this system.
              </p>
            </div>
          </FadeInOnScroll>
        </div>
        <div className={styles.about}>
          <FadeInOnScroll>
            <div className={styles.block}>
              <h2>Disc Golf</h2>
              <p>
                Disc golf is a sport that is played much like traditional golf,
                but instead of hitting a ball into a hole, players throw a
                flying disc into a target. The first game of disc golf was
                played in the late 1960s, but it wasn't until the 1970s that the
                sport really started to take off. Recent years have seen the
                game explode in popularity, especially since Covid-19.
              </p>
            </div>
          </FadeInOnScroll>
          <FadeInOnScroll>
            <div className={styles.block}>
              <h2>The PDGA</h2>
              <p>
                According to the Professional Disc Golf Association (PDGA),
                there are over 50,000 active members and over 7,500 courses
                worldwide. The sport has gained popularity over the years, with
                many amateur and professional players competing in local and
                national tournaments.
              </p>
              <img src={pdga} alt="pdga stats"></img>
            </div>
          </FadeInOnScroll>
          <FadeInOnScroll>
            <div className={styles.block}>
              <h2>COVID-19 contributed directly to the game's growth</h2>
              <p>
                At the onset of the pandemic, people were eager to find safe
                alternatives to traditional indoor sports. The social distancing
                and immersion in nature promised by disc golf were incredibly
                appetizing to tens of thousands of people. The sport maintained
                this growth even as the pandemic came to an end.
              </p>
              <p>
                Over 70% of all disc golf courses in the world have been built
                within the last decade. Various factors are contributing to this
                rapid growth: Covid-19, environmental considerations, and simply
                how fun the game is to play.
              </p>
              <p>
                Disc golf is a great way to get outside and enjoy some fresh air
                while also getting exercise. It's a sport that can be enjoyed by
                people of all ages and skill levels, and it's easy to get
                started.
              </p>
            </div>
          </FadeInOnScroll>
          <FadeInOnScroll>
            <div className={styles.block}>
              <h2>
                People are more concerned about the environmental impacts of
                their hobbies
              </h2>
              <img src={parks} alt="park stats"></img>
              <p>
                As society has developed in the 21st century, an awareness of
                human impact on the environment has become significantly more
                prevalent. As this sense has increased in the population, more
                and more people have become aware of the impact that their
                hobbies have on the world around them. The disc golf community
                prides itself on being a sport that minimally invades ecosystems
                and does not require massive renovation of natural landscape
                that other sports tend to need.
              </p>
            </div>
          </FadeInOnScroll>

          <FadeInOnScroll>
            <div className={styles.block}>
              <h2>Success Stories of Golf Simulators</h2>
              <p>
                The success of TopGolf and Trackman technologies in the golfing
                world is undeniable. These companies have revolutionized the way
                golf is played, making it more accessible and engaging for
                players of all levels. At Hyzerberg Technologies, we believe
                that disc golf has the potential to have a similar impact, and
                our simulator is the first step in that direction.
              </p>
            </div>
          </FadeInOnScroll>
          <FadeInOnScroll>
            <div className={styles.block}>
              <h2>Resources for Disc Golf Enthusiasts</h2>
              <p>
                If you're interested in learning more about disc golf, the
                Professional Disc Golf Association (PDGA) website is a great
                resource. You can find information about local courses, upcoming
                tournaments, and connect with other players in your area.
                Additionally, there are a number of online communities, such as
                Reddit's /r/discgolf, where you can discuss strategy, equipment,
                and more with other enthusiasts.
              </p>
              <p>
                We believe that disc golf is a rapidly growing sport that has
                been overlooked by the technology industry. Our simulator will
                help to grow the sport by providing a fun and engaging way to
                practice and play year-round.
              </p>
            </div>
          </FadeInOnScroll>
        </div>
      </div>
    </Fragment>
  );
};

export default AboutPage;
